import { render, staticRenderFns } from "./StagingMergePanel.vue?vue&type=template&id=a1351454&scoped=true&"
import script from "./StagingMergePanel.vue?vue&type=script&lang=ts&"
export * from "./StagingMergePanel.vue?vue&type=script&lang=ts&"
import style0 from "./StagingMergePanel.vue?vue&type=style&index=0&id=a1351454&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1351454",
  null
  
)

export default component.exports